import React from 'react';
import { IDetailField } from '../../../stores/service-finance.store';
import * as Styles from './details-review-item.less';

interface IDetailTableProps {
    header: string;
    onClickAction: () => void;
    details: IDetailField[][];
}

export const DetailsReviewItem: React.FC<IDetailTableProps> = ({
    header,
    onClickAction,
    details,
}) => {
    return (
        <>
            <div className={Styles.field}>
                <span>{header}</span>
                <a className={Styles.link} onClick={onClickAction}>
                    Edit
                </a>
            </div>
            <table className={Styles.table}>
                <tbody>
                    {details.map((row, index) => (
                        <tr key={index}>
                            {row.map((detail, innerIndex) => (
                                <td className={Styles.cell} key={innerIndex}>
                                    <div>{detail.title}</div>
                                    <div>{detail.value}</div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};
